import type { ApiClient } from "@carepass/api-client";
import type { Schemas } from "../workspace/api.generated";
import type { ContentStatus, ContentType } from "./schema";

export interface ContentListQuery {
  readonly type: ContentType;
  readonly status: ContentStatus | "";
}

export async function getContents(api: ApiClient, query: ContentListQuery, signal?: AbortSignal) {
  return (await api.get<Schemas["ContentPostView"][]>("/api/v1/admin/contents", {
    query: { type: query.type, status: query.status || undefined }, signal, cache: "no-store",
  })).data;
}

export async function getContent(api: ApiClient, id: number, signal?: AbortSignal) {
  return (await api.get<Schemas["ContentPostView"]>(`/api/v1/admin/contents/${id}`, { signal, cache: "no-store" })).data;
}

export async function createContent(api: ApiClient, body: Schemas["SaveContentRequest"], signal?: AbortSignal) {
  return (await api.post<Schemas["ContentPostView"], Schemas["SaveContentRequest"]>("/api/v1/admin/contents", body, { signal, cache: "no-store" })).data;
}

export async function updateContent(api: ApiClient, id: number, body: Schemas["SaveContentRequest"], signal?: AbortSignal) {
  return (await api.put<Schemas["ContentPostView"], Schemas["SaveContentRequest"]>(`/api/v1/admin/contents/${id}`, body, { signal, cache: "no-store" })).data;
}

export async function publishContent(api: ApiClient, id: number, signal?: AbortSignal) {
  return (await api.post<Schemas["ContentPostView"]>(`/api/v1/admin/contents/${id}/publish`, undefined, { signal, cache: "no-store" })).data;
}

export async function archiveContent(api: ApiClient, id: number, signal?: AbortSignal) {
  return (await api.post<Schemas["ContentPostView"]>(`/api/v1/admin/contents/${id}/archive`, undefined, { signal, cache: "no-store" })).data;
}

export async function deleteContent(api: ApiClient, id: number, body: Schemas["DeleteContentRequest"], signal?: AbortSignal) {
  return (await api.request<void, Schemas["DeleteContentRequest"]>("DELETE", `/api/v1/admin/contents/${id}`, { body, signal, cache: "no-store" })).data;
}
